var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import ReactModal from 'react-modal';
import classnames from 'classnames';
import { CloseButton } from './CloseButton';
import { Buttons } from './Buttons';
import { MessageText } from './MessageText';
import { Typography } from '../../foundations/typography';
import styles from './Modal.module.scss';
/**
 * @tdr
 */
export var Modal = function (_a) {
    var _b, _c, _d, _e;
    var ariaDescribedBy = _a.ariaDescribedBy, ariaLabelledBy = _a.ariaLabelledBy, _f = _a.buttonOrientation, buttonOrientation = _f === void 0 ? 'horizontal' : _f, buttons = _a.buttons, _g = _a.cannotClose, cannotClose = _g === void 0 ? false : _g, children = _a.children, _h = _a.closeButtonTheme, closeButtonTheme = _h === void 0 ? 'dark' : _h, className = _a.className, handleModalClose = _a.handleModalClose, dataTest = _a.dataTest, _j = _a.fullScreen, fullScreen = _j === void 0 ? false : _j, _k = _a.isOpen, isOpen = _k === void 0 ? false : _k, _l = _a.messageIsHtml, messageIsHtml = _l === void 0 ? false : _l, messageText = _a.messageText, messageTextParams = _a.messageTextParams, _m = _a.scrollable, scrollable = _m === void 0 ? false : _m, titleText = _a.titleText, webViewId = _a.webViewId, _o = _a.blockScroll, blockScroll = _o === void 0 ? true : _o, contentClassName = _a.contentClassName, _p = _a.standardHeadingEnabled, standardHeadingEnabled = _p === void 0 ? true : _p, props = __rest(_a, ["ariaDescribedBy", "ariaLabelledBy", "buttonOrientation", "buttons", "cannotClose", "children", "closeButtonTheme", "className", "handleModalClose", "dataTest", "fullScreen", "isOpen", "messageIsHtml", "messageText", "messageTextParams", "scrollable", "titleText", "webViewId", "blockScroll", "contentClassName", "standardHeadingEnabled"]);
    var applyWebviewId = useCallback(function (ref) {
        if (!ref) {
            return;
        }
        var dataset = ref.dataset;
        if (webViewId) {
            dataset.webviewid = webViewId;
        }
        else {
            delete dataset.webviewid;
        }
    }, [webViewId]);
    var contentLabel = ariaLabelledBy ? undefined : titleText;
    var verticalButtons = buttonOrientation === 'vertical';
    return (React.createElement(ReactModal, __assign({ className: classnames(styles.modal, (_b = {}, _b[styles.fullScreen] = fullScreen, _b), className), contentLabel: contentLabel, overlayRef: applyWebviewId, isOpen: isOpen, onRequestClose: handleModalClose &&
            (function (event) {
                return handleModalClose({
                    label: 'close',
                    value: 'close',
                    domEvent: event,
                });
            }), overlayClassName: classnames(styles.modalOverlay, (_c = {},
            _c[styles.modalOverlayOpen] = isOpen,
            _c)), shouldCloseOnOverlayClick: !cannotClose, shouldCloseOnEsc: !cannotClose, aria: __assign(__assign({}, (ariaDescribedBy ? { describedby: ariaDescribedBy } : {})), (ariaLabelledBy ? { labelledby: ariaLabelledBy } : {})), bodyOpenClassName: styles.modalOpen, onAfterOpen: function () {
            if (blockScroll) {
                document.body.style.top = "-".concat(window.scrollY, "px");
                document.body.style.position = 'fixed';
            }
        }, onAfterClose: function () {
            if (blockScroll) {
                var scrollY_1 = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY_1 || '0', 10) * -1);
            }
        } }, props),
        React.createElement("section", { "data-test": dataTest, "data-webviewid": "popup", className: classnames(styles.modalContainer, (_d = {}, _d[styles.scrollable] = scrollable, _d)) },
            standardHeadingEnabled ? (React.createElement("header", { className: styles.modalHeader },
                React.createElement("div", { className: styles.modalHeading },
                    React.createElement(Typography, { styleAs: "paragraphHeading", element: "h2", noMargins: true, className: styles.modalTitle }, titleText)),
                !cannotClose && handleModalClose && (React.createElement("div", { className: styles.closeButtonWithStandardHeader },
                    React.createElement(CloseButton, { className: styles.closeButton, close: function (event) {
                            return handleModalClose({
                                domEvent: event,
                                label: 'close',
                                value: 'close',
                            });
                        }, theme: closeButtonTheme }))))) : (!cannotClose &&
                handleModalClose && (React.createElement(CloseButton, { className: styles.closeButtonWithoutStandardHeader, close: function (event) {
                    return handleModalClose({
                        domEvent: event,
                        label: 'close',
                        value: 'close',
                    });
                }, theme: closeButtonTheme }))),
            React.createElement("div", { id: "modalDescription", className: classnames(styles.modalContent, (_e = {},
                    _e[styles.noPaddingBottom] = buttons === null || buttons === void 0 ? void 0 : buttons.length,
                    _e), contentClassName) },
                !!messageText && (React.createElement(MessageText, { isHtml: messageIsHtml, params: messageTextParams, text: messageText })),
                children),
            !!(buttons === null || buttons === void 0 ? void 0 : buttons.length) && (React.createElement(Buttons, __assign({}, { verticalButtons: verticalButtons, buttons: buttons, closeModal: handleModalClose }))))));
};
Modal.setAppElement = ReactModal.setAppElement;
//# sourceMappingURL=Modal.js.map